import { ANY_CARRIER, TruckingWhitelistRule } from './rule';

export const formatRule = (rule: TruckingWhitelistRule) =>
  [
    rule.isDeny ? '!' : '',
    rule.scac?.trim() || ANY_CARRIER,
    rule.broker?.trim() ? `/${rule.broker.trim()}` : '',
    rule.integration?.trim() ? `:${rule.integration.trim()}` : '',
    rule.origin?.trim() ? `@${rule.origin.trim().toUpperCase()}` : '',
    rule.fpAccountId ? `#${rule.fpAccountId}` : '',
  ].join('');

export const formatRules = (rules: TruckingWhitelistRule[]) => rules.map(formatRule).join(', ');
